import React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import CmsBlock from "app/layout/cmsBlock";

import Video from "./video";
const CustomizationSection = () => {
  return (
    <MDBContainer fluid className="customization-wrapper p-0">
      <MDBRow className="customization-inner">
        <MDBCol lg="6" className={`customization-video`}>
          <Video />
        </MDBCol>
        <MDBCol lg="6" className={`customization-text-wrapper`}>
          <CmsBlock id={"customization_content_v2"} />
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default CustomizationSection;
